import script from "./CoveragePreviewSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoveragePreviewSummary.vue?vue&type=script&setup=true&lang=ts"

import "./CoveragePreviewSummary.vue?vue&type=style&index=0&id=0678f838&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0678f838"]])

export default __exports__